import {Component} from "@angular/core";
import {Field} from "../models/field.model";
import {DetailService} from "../../../services/details/detail.service";
import {HttpParams} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {ENVIRONMENT} from "../../../../environments/environment";
import {ContentsHelper} from "../../../helpers/contents.helper";


@Component({
	selector: "tig-form-input-search",
	template: `
		<div class="form-group" [formGroup]="OBJ_form_group" [ngClass]="{'has-error': isInvalid()}">
			<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
				<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon" [tooltip]="tooltipTemplate" placement="top" triggers="click" containerClass="tig-tooltip" delay="50"></i>
				<span *ngIf="isRequired()" class="tgi-asterisk"> *</span>
			</label>
			<div class="col-lg-8">
				<input title="{{getHint()|translate}}"
					class="form-control"
					[placeholder]="getLabelName()|translate"
					[formControlName]="OBJ_field_config.name"
					(change)="modelChanged($event)"
					(blur)="setValue($event)"
				/>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
				<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
				<div *ngIf="ARR_proposals">
					<a *ngFor="let OBJ_entry of this.ARR_proposals"
						href="{{ STR_route + OBJ_contents_helper.findId(OBJ_entry)}}"
						target="_blank">{{"oMisc.sEntryFound"|translate}} <i class="fa fa-external-link"></i>
					</a>
				</div>
			</div>
		</div>
	`
})
export class FormInputSearchComponent extends Field {

	OBJ_contents_helper: ContentsHelper;
	STR_route: string;
	ARR_proposals: Array<any> = [];
	private STR_id_self: string;

	constructor(
		private OBJ_detail_service: DetailService,
		private OBJ_route: ActivatedRoute
	) {
		super();
		let STR_wcms = "";
		if (ENVIRONMENT.env === 'development') {
			STR_wcms = 'wcms/';
		} // end if

		// Build correct submenu path
		let STR_route_submenu = OBJ_route.snapshot.routeConfig.path;
		STR_route_submenu = STR_route_submenu.replace(":route_submenu", OBJ_route.snapshot.paramMap.get("route_submenu"));
		STR_route_submenu = STR_route_submenu.replace(":id", '');

		// Build route to possible duplicate entry
		this.STR_route = STR_wcms + OBJ_route.snapshot.parent.paramMap.get("route_menu") + '/' + STR_route_submenu;
		this.STR_id_self = OBJ_route.snapshot.paramMap.get('id');
	} // end constructor


	/**
	 * Function > modelChanged
	 * @param $event
	 */
	public modelChanged($event) {
		this.ARR_proposals = null;

		if ($event.target.value !== "") {
			let BOO_exact_match: boolean = true;
			if (this.OBJ_field_config.exact_match === false) {
				BOO_exact_match = false;
			}

			let OBJ_params = new HttpParams()
				.set('searchtext', $event.target.value)
				.set('searchfields', this.OBJ_field_config.name)
				.set('exactmatch', BOO_exact_match.toString())
				.set('excluded_id', this.STR_id_self);

			this.OBJ_detail_service.getHelper(this.OBJ_field_config._links.options.href, OBJ_params, 'formInputComponent')
				.subscribe((OBJ_result: ContentsHelper) => {
					this.OBJ_contents_helper = OBJ_result;
					this.ARR_proposals = OBJ_result.getListingData();
				});
		} // end if
	} // end function modelChanged


	/**
	 * Function > setValue
	 * @desc
	 * @param OBJ_event
	 */
	setValue(OBJ_event: any) {
		super.setValue(OBJ_event.target.value || null);

	} // end function setValue

} // end class FormInputComponent
